import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.85 11.523 21.153 1.76a.918.918 0 0 0-1.807.315l1.698 9.762q.012.082.02.163H17.5a1.835 1.835 0 0 0-1.833 1.834 1.835 1.835 0 0 1-1.834 1.833h-3.666a1.835 1.835 0 0 1-1.833-1.833A1.835 1.835 0 0 0 6.499 12H2.934c.008-.054.011-.11.02-.164l1.7-9.762a.917.917 0 0 0-1.808-.314L1.15 11.522c-.075.43-.15 1.636-.15 1.728v5.167A4.59 4.59 0 0 0 5.584 23h12.833A4.59 4.59 0 0 0 23 18.417V13.25c0-.092-.074-1.3-.15-1.728m-4.433 9.644H5.584a2.753 2.753 0 0 1-2.75-2.75v-4.583H6.5a3.67 3.67 0 0 0 3.667 3.666h3.666a3.67 3.67 0 0 0 3.667-3.666h3.667v4.583a2.753 2.753 0 0 1-2.75 2.75M6.702 1.75c.08-.434.46-.75.9-.75h8.804a.918.918 0 0 1 0 1.834H7.604a.916.916 0 0 1-.901-1.084zM5.345 9.084c.08-.435.46-.75.901-.75h11.51a.918.918 0 0 1 0 1.833H6.247a.916.916 0 0 1-.9-1.083zm.679-3.667c.08-.435.459-.75.9-.75h10.157a.918.918 0 0 1 0 1.833H6.926a.917.917 0 0 1-.902-1.083"
    }, null, -1)
  ]))]))
}
export default { render: render }